module.exports = __webpack_public_path__ + "static/media/wirte.ce5a2bf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wirte.png
// module id = 641
// module chunks = 0